<app-loading-state [isLoading]="isLoading" [loadedContent]="loadedContent" style="display: contents"></app-loading-state>
<ng-template #loadedContent>
	<div class="offcanvas-header">
		<div class="left">
			<div class="status-icon" [style.background-color]="getScheduledAssessmentColour(scheduledAssessment.status)"></div>
			<h3 class="offcanvas-title">
				Job Card
				<div class="header-subtitle">Employee: {{ scheduledAssessment.assignedEmployee.name }}</div>
			</h3>
		</div>
		<button type="button" class="btn-close" aria-label="Close" (click)="close()"></button>
	</div>
	<hr class="mx-3" />
	<div class="offcanvas-body">
		<div class="body">
			<div class="row-item">
				<app-standard-control
					[formGroup]="form"
					class="w-100"
					name="startTime"
					type="time"
					label="Start Time"
					placeholder="Start Time"
				></app-standard-control>
				<app-standard-control
					[formGroup]="form"
					class="w-100"
					name="endTime"
					type="time"
					label="End Time"
					placeholder="End Time"
				></app-standard-control>
			</div>

			<div class="row-item">
				<ng-container *ngIf="scheduledAssessment.signedJobCard">
					<app-alert
						[alertType]="AlertTypes.WARNING"
						content="This Job Card has been signed, any changes made will not be reflected on the signed Job Card."
						[dismissible]="true"
						[marginBottom]="0"
					></app-alert>
				</ng-container>
				<ng-container *ngIf="form.controls.startTime.value && form.controls.startTime.value === form.controls.endTime.value">
					<app-alert
						class="w-100"
						[alertType]="AlertTypes.DANGER"
						content="Start Time and End Time cannot be the same."
						[dismissible]="true"
						[marginBottom]="0"
					></app-alert>
				</ng-container>
			</div>
			<div class="row-item">
				<ng-container *ngIf="!scheduledAssessment.jobCard.startTime">
					<button type="button" class="btn btn-success w-100" (click)="startJob()">Start Job</button>
				</ng-container>
				<ng-container *ngIf="scheduledAssessment.jobCard.startTime && !scheduledAssessment.jobCard.endTime">
					<button type="button" class="btn btn-danger w-100" (click)="endJob()">End Job</button>
				</ng-container>
			</div>

			<div class="column-item">
				<h5 class="text-primary">Job Status</h5>
				<app-assessment-status-dropdown
					[(status)]="scheduledAssessment.status"
					[readonlyView]="form.dirty"
					(statusChange)="statusChange($event)"
					[statusOptions]="isOwner ? leadAssessmentStatusOptions : leadAssessmentRestrictedStatusOptions"
				></app-assessment-status-dropdown>
			</div>

			<div class="column-item">
				<app-header-popover heading="Job Notes" headingSize="h5" [infoPopOver]="jobNotesPopOver"></app-header-popover>
				<app-textarea-control
					[resizable]="true"
					[height100]="false"
					[heightPx]="150"
					name="jobNotes"
					[formGroup]="form"
					label="Job Notes"
					placeholder="Job Notes"
				></app-textarea-control>
			</div>

			<div class="column-item border-item">
				<app-step-navigator [stepConfig]="navigationConfig" [(selectedStep)]="selectedStep"></app-step-navigator>

				<ng-container [ngSwitch]="selectedStep.switchCase">
					<ng-container *ngSwitchCase="JobCardViewSteps.MATERIALS">
						<app-job-card-materials
							[form]="form"
							[inventoryItems]="inventoryItemsList"
							(addMaterial)="addMaterialFormItem()"
							(removeMaterial)="removeMaterialFormItem($event)"
						></app-job-card-materials>
					</ng-container>
					<ng-container *ngSwitchCase="JobCardViewSteps.ATTACHMENTS">
						<app-job-card-attachments
							[form]="form"
							[organisationId]="scheduledAssessment.organisationId"
							[leadRequestId]="scheduledAssessment.leadRequestId"
							[scheduledAssessmentId]="leadAssessmentId"
							[mustRefreshAttachments]="mustRefreshAttachments"
							[disabled]="isSaving"
						></app-job-card-attachments>
					</ng-container>
				</ng-container>
			</div>
		</div>

		<div class="footer">
			<div class="actions">
				<div class="buttons">
					<button
						type="button"
						class="btn btn-sm btn-outline-primary w-100"
						(click)="viewAndSign()"
						[disabled]="form.invalid || isSaving"
					>
						<ng-container *ngIf="!scheduledAssessment.signedJobCard; else mustSign">
							<i class="bi bi-pencil-square"></i>
							View and Sign
						</ng-container>
						<ng-template #mustSign>
							<i class="bi bi-pencil-square"></i>
							View Signed Card
						</ng-template>
					</button>
					<button
						type="button"
						class="btn btn-sm btn-primary w-100"
						(click)="saveJobCard()"
						[disabled]="form.pristine || isSaving"
					>
						<ng-container *ngIf="isSaving; else notLoading">
							<div class="spinner-border spinner-border-sm" role="status">
								<span class="visually-hidden">Loading...</span>
							</div>
						</ng-container>
						<ng-template #notLoading>
							<i class="bi bi-floppy"></i>
							Save
						</ng-template>
					</button>
				</div>
			</div>
		</div>
	</div>
</ng-template>
